import PropTypes from "prop-types"


const InvestmentProfileShape = PropTypes.exact({
  profileType: PropTypes.string,
  investments: PropTypes.arrayOf(PropTypes.exact({
    projectTierId: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  })).isRequired,
})

export default InvestmentProfileShape
